import { membershipService } from '@libs/data-access/queries'
import { DropdownMenu, Tooltip, TopNavbar } from '@libs/ui/ds'
import { useAppNavBarTranslation } from '@libs/utils/translations'
import type { FC } from 'react'

import { NotificationsDropdownMenuContent } from './NotificationsDropdownMenuContent'

export const NotificationsNavItem: FC = () => {
  const { t } = useAppNavBarTranslation()

  const membershipNotifications =
    membershipService.membership.notifications.useFetchNotifications(
      {
        queryParams: {
          reset_cache: true
        }
      },
      { enabled: false }
    )

  const onOpen = () => {
    membershipNotifications.refetch()
  }

  return (
    <DropdownMenu
      dropdownPosition='bottom-end'
      dropdownWidth='l'
      onOpen={onOpen}
    >
      <DropdownMenu.Target>
        <Tooltip label={t('notifications.title')}>
          <TopNavbar.Notification
            count={membershipNotifications.data?.total_count}
          />
        </Tooltip>
      </DropdownMenu.Target>

      <NotificationsDropdownMenuContent
        notifications={membershipNotifications.data}
        count={membershipNotifications.data?.total_count}
        isLoading={membershipNotifications.isPending}
      />
    </DropdownMenu>
  )
}
